// const url = 'http://localhost:3001' // local url
// const url = 'https://api-stg.waveskw.com' // staging url
const url = 'https://api.waveskw.com' // live url

module.exports = {
  getAPI: function () {
    return `${url}/api`
  },
  getImage: function () {
    return url
  },
  socketUrl: function () {
    return url
  },

  nameMaxLength: 20,
  descMaxLength: 200,

  getLanguageList: function () {
    var languages = [
      {
        id: 'en',
        name: 'English',
      },
      {
        id: 'ar',
        name: 'Arabic',
      },
    ]

    return languages
  },

  roundToMax3Decimals: function (num) {
    return Math.round(num * 1000) / 1000
  },

  getAuthLogout: function () {
    let rememberData = localStorage.getItem('user_login_details') || null
    localStorage.clear()
    localStorage.setItem('user_login_details', rememberData)

    window.location.href = '#/'
    window.location.reload()
  },

  isPhoneNumberValid: function (number = '', country) {
    switch (country) {
      case '+966':
      case 'KSA':
        return { msg: 'Phone Number must have 9 or 10 Digits', valid: number.length == 9 || number.length == 10 }
      case '+971':
      case 'UAE':
        return { msg: 'Phone Number must have 9 Digits', valid: number.length == 9 }
      case '+965':
      case 'KWT':
        return { msg: 'Phone Number must have 8 Digits', valid: number.length == 8 }
      case '+974':
      case 'QAT':
        return { msg: 'Phone Number must have 8 Digits', valid: number.length == 8 }
      case '+90':
      case 'TUR':
        return { msg: 'Phone Number must have 10 Digits', valid: number.length == 10 }
      case '+66':
      case 'THA':
        return { msg: 'Phone Number must have 9 Digits', valid: number.length == 9 }
      default:
        break
    }
  },

  getUserTypes: () => {
    return [
      { label: 'Customers', value: 'user' },
      { label: 'Owner of boats', value: 'admin' },
      { label: 'Boat Captain', value: 'captain' },
      { label: 'Store supplier', value: 'store' },
      { label: 'Chalet Owner', value: 'chalet-owner' },
      { label: 'Trainer(Event Vendor)', value: 'event-vendor' },
      { label: 'Vendor', value: 'vendor' },
      { label: 'Ops Coordinator', value: 'ops-coord' },
      // { label: 'Sr. Ops Coordinator', value: 'sr-ops-coord' },
      { label: 'Ops Supervisor', value: 'ops-sup' },
      // { label: 'Ops Manager', value: 'ops-mgr' },
      { label: 'Marketing Manager', value: 'mkt-mgr' },
      { label: 'Marketing Coordinator', value: 'mkt-coord' },
      { label: 'Sales Manager', value: 'sales-mgr' },
      { label: 'Sales Member', value: 'sales-member' },
      { label: 'Finance Manager', value: 'finance-mgr' },
      { label: 'Finance Member', value: 'finance-member' },
      { label: 'Owners', value: 'owners' },
      { label: 'Concierge', value: 'concierge' },
      { label: 'Car Owner', value: 'car-owner' },
      { label: 'Port Admin', value: 'port-admin' },

      // { label: 'Super Admin', value: 'super-admin' },
      { label: 'Third Party', value: 'third-party' },

      { label: 'Wego Admin', value: 'wego-admin' },
    ]
  },

  getAdminLoginRoles: () => {
    return [
      { label: 'Super Admin', value: 'super-admin' },

      { label: 'Owner of boats', value: 'admin' },
      { label: 'Boat Captain', value: 'captain' },
      { label: 'Store supplier', value: 'store' },
      { label: 'Vendor', value: 'vendor' },

      { label: 'Ops Coordinator', value: 'ops-coord' },
      // { label: 'Sr. Ops Coordinator', value: 'sr-ops-coord' },
      { label: 'Ops Supervisor', value: 'ops-sup' },
      // { label: 'Ops Manager', value: 'ops-mgr' },
      { label: 'Marketing Manager', value: 'mkt-mgr' },
      { label: 'Marketing Coordinator', value: 'mkt-coord' },
      { label: 'Sales Manager', value: 'sales-mgr' },
      { label: 'Sales Member', value: 'sales-member' },
      { label: 'Finance Manager', value: 'finance-mgr' },
      { label: 'Finance Member', value: 'finance-member' },
      { label: 'Owners', value: 'owners' },
      { label: 'Concierge', value: 'concierge' },
      { label: 'Port Admin', value: 'port-admin' },

      { label: 'Wego Admin', value: 'wego-admin' },
    ]
  },

  getAllUserTypes: () => {
    return [
      { label: 'Customers', value: 'user' },
      { label: 'Owner of boats', value: 'admin' },
      { label: 'Boat Captain', value: 'captain' },
      { label: 'Store supplier', value: 'store' },
      { label: 'Chalet Owner', value: 'chalet-owner' },
      { label: 'Trainer(Event Vendor)', value: 'event-vendor' },
      { label: 'Vendor', value: 'vendor' },
      { label: 'Ops Coordinator', value: 'ops-coord' },
      // { label: 'Sr. Ops Coordinator', value: 'sr-ops-coord' },
      { label: 'Ops Supervisor', value: 'ops-sup' },
      // { label: 'Ops Manager', value: 'ops-mgr' },
      { label: 'Marketing Manager', value: 'mkt-mgr' },
      { label: 'Marketing Coordinator', value: 'mkt-coord' },
      { label: 'Sales Manager', value: 'sales-mgr' },
      { label: 'Sales Member', value: 'sales-member' },
      { label: 'Finance Manager', value: 'finance-mgr' },
      { label: 'Finance Member', value: 'finance-member' },
      { label: 'Owners', value: 'owners' },
      { label: 'Concierge', value: 'concierge' },
      { label: 'Car Owner', value: 'car-owner' },
      { label: 'Port Admin', value: 'port-admin' },

      { label: 'Super Admin', value: 'super-admin' },
      { label: 'Third Party', value: 'third-party' },

      { label: 'Wego Admin', value: 'wego-admin' },
    ]
  },

  getTypeTags: function () {
    return ['B2B', 'B2C', 'MARKETING', 'SERVICE RECOVERY', 'TICKET', 'TEST']
  },

  toCamelCase: function (str) {
    return str.replace(/\b\w/g, function (match) {
      return match.toUpperCase()
    })
  },

  getCountryTimeZone: function (country) {
    switch (country) {
      case 'UAE':
        return 'Asia/Dubai'
      case 'KSA':
        return 'Asia/Riyadh'
      case 'QAT':
        return 'Asia/Qatar'
      case 'THA':
        return 'Asia/Bangkok'
      case 'TUR':
        return 'Europe/Istanbul'
      case 'KWT':
      default:
        return 'Asia/Kuwait'
    }
  },

  getCountryFullName: function (country) {
    switch (country) {
      case 'UAE':
        return 'United Arab Emirates'
      case 'KSA':
        return 'Saudi Arabia'
      case 'QAT':
        return 'Qatar'
      case 'THA':
        return 'Thailand'
      case 'TUR':
        return 'Turkey'
      case 'KWT':
      default:
        return 'Kuwait'
    }
  },

  getCurrency: function (country) {
    switch (country) {
      case 'QAT':
        return 'QAR'
      case 'KSA':
        return 'SAR'
      case 'UAE':
        return 'AED'
      case 'THA':
        return 'EUR'
      case 'TUR':
        return 'EUR'
      case 'KWT':
      default:
        return 'KWD'
    }
  },

  getVat: function (country) {
    switch (country) {
      case 'KSA':
      case 'SAR':
        return 15
      case 'UAE':
      case 'AED':
        return 5
      case 'THA':
      case 'THB':
        return 7
      case 'TUR':
      case 'TRY':
        return 20
      case 'KWT':
      case 'KWD':
      case 'QAT':
      case 'QAR':
      default:
        return 0
    }
  },

  getBasketSizeLimits: function (country, eventType) {
    let defaultValues = {
      min: 50,
      max: 150,
      maxColor: '#d4ffdc',
      minColor: '#ffe4e4',
    }

    if (eventType == 'c') {
      switch (country) {
        case 'KSA':
        case 'UAE':
        case 'QAT':
        case 'KWT':
        default:
          break
      }
    } else if (eventType == 'ch') {
      switch (country) {
        case 'KSA':
        case 'UAE':
        case 'QAT':
        case 'KWT':
        default:
          break
      }
    } else if (eventType == 'e') {
      switch (country) {
        case 'KSA':
        case 'UAE':
        case 'QAT':
        case 'KWT':
        default:
          break
      }
    }

    return defaultValues
  },

  getMinimumBookingSlots: function () {
    const hourSlots = []
    for (let i = 0; i <= 24; i++) {
      const label = ('0' + i).slice(-2) + ':00' // Pad single digits with a leading zero
      const value = ('0' + i).slice(-2) + ':00:00'
      hourSlots.push({ label, value, enable: false })
    }

    return [
      ...hourSlots,
      { label: '36:00', value: '36:00:00' },
      { label: '48:00', value: '48:00:00' },
      { label: '60:00', value: '60:00:00' },
      { label: '72:00', value: '72:00:00' },
    ]
  },

  getHourSlots: function () {
    const hourSlots = []
    for (let i = 0; i <= 24; i++) {
      const label = ('0' + i).slice(-2) + ':00' // Pad single digits with a leading zero
      const value = ('0' + i).slice(-2) + ':00:00'
      hourSlots.push({ label, value, enable: false })
    }
    return hourSlots
  },

  getHalfHourSlots: function () {
    return [
      { label: '00:00', value: '00:00:00' },
      { label: '00:30', value: '00:30:00' },
      { label: '01:00', value: '01:00:00' },
      { label: '01:30', value: '01:30:00' },
      { label: '02:00', value: '02:00:00' },
      { label: '02:30', value: '02:30:00' },
      { label: '03:00', value: '03:00:00' },
      { label: '03:30', value: '03:30:00' },
      { label: '04:00', value: '04:00:00' },
      { label: '04:30', value: '04:30:00' },
      { label: '05:00', value: '05:00:00' },
      { label: '05:30', value: '05:30:00' },
      { label: '06:00', value: '06:00:00' },
      { label: '06:30', value: '06:30:00' },
      { label: '07:00', value: '07:00:00' },
      { label: '07:30', value: '07:30:00' },
      { label: '08:00', value: '08:00:00' },
      { label: '08:30', value: '08:30:00' },
      { label: '09:00', value: '09:00:00' },
      { label: '09:30', value: '09:30:00' },
      { label: '10:00', value: '10:00:00' },
      { label: '10:30', value: '10:30:00' },
      { label: '11:00', value: '11:00:00' },
      { label: '11:30', value: '11:30:00' },
      { label: '12:00', value: '12:00:00' },
      { label: '12:30', value: '12:30:00' },
      { label: '13:00', value: '13:00:00' },
      { label: '13:30', value: '13:30:00' },
      { label: '14:00', value: '14:00:00' },
      { label: '14:30', value: '14:30:00' },
      { label: '15:00', value: '15:00:00' },
      { label: '15:30', value: '15:30:00' },
      { label: '16:00', value: '16:00:00' },
      { label: '16:30', value: '16:30:00' },
      { label: '17:00', value: '17:00:00' },
      { label: '17:30', value: '17:30:00' },
      { label: '18:00', value: '18:00:00' },
      { label: '18:30', value: '18:30:00' },
      { label: '19:00', value: '19:00:00' },
      { label: '19:30', value: '19:30:00' },
      { label: '20:00', value: '20:00:00' },
      { label: '20:30', value: '20:30:00' },
      { label: '21:00', value: '21:00:00' },
      { label: '21:30', value: '21:30:00' },
      { label: '22:00', value: '22:00:00' },
      { label: '22:30', value: '22:30:00' },
      { label: '23:00', value: '23:00:00' },
      { label: '23:30', value: '23:30:00' },
      { label: '24:00', value: '24:00:00' },
    ]
  },

  getTwentyMinuteSlots: function () {
    return [
      { label: '00:00', value: '00:00:00' },
      { label: '00:20', value: '00:20:00' },
      { label: '00:40', value: '00:40:00' },
      { label: '01:00', value: '01:00:00' },
      { label: '01:20', value: '01:20:00' },
      { label: '01:40', value: '01:40:00' },
      { label: '02:00', value: '02:00:00' },
      { label: '02:20', value: '02:20:00' },
      { label: '02:40', value: '02:40:00' },
      { label: '03:00', value: '03:00:00' },
      { label: '03:20', value: '03:20:00' },
      { label: '03:40', value: '03:40:00' },
      { label: '04:00', value: '04:00:00' },
      { label: '04:20', value: '04:20:00' },
      { label: '04:40', value: '04:40:00' },
      { label: '05:00', value: '05:00:00' },
      { label: '05:20', value: '05:20:00' },
      { label: '05:40', value: '05:40:00' },
      { label: '06:00', value: '06:00:00' },
      { label: '06:20', value: '06:20:00' },
      { label: '06:40', value: '06:40:00' },
      { label: '07:00', value: '07:00:00' },
      { label: '07:20', value: '07:20:00' },
      { label: '07:40', value: '07:40:00' },
      { label: '08:00', value: '08:00:00' },
      { label: '08:20', value: '08:20:00' },
      { label: '08:40', value: '08:40:00' },
      { label: '09:00', value: '09:00:00' },
      { label: '09:20', value: '09:20:00' },
      { label: '09:40', value: '09:40:00' },
      { label: '10:00', value: '10:00:00' },
      { label: '10:20', value: '10:20:00' },
      { label: '10:40', value: '10:40:00' },
      { label: '11:00', value: '11:00:00' },
      { label: '11:20', value: '11:20:00' },
      { label: '11:40', value: '11:40:00' },
      { label: '12:00', value: '12:00:00' },
      { label: '12:20', value: '12:20:00' },
      { label: '12:40', value: '12:40:00' },
      { label: '13:00', value: '13:00:00' },
      { label: '13:20', value: '13:20:00' },
      { label: '13:40', value: '13:40:00' },
      { label: '14:00', value: '14:00:00' },
      { label: '14:20', value: '14:20:00' },
      { label: '14:40', value: '14:40:00' },
      { label: '15:00', value: '15:00:00' },
      { label: '15:20', value: '15:20:00' },
      { label: '15:40', value: '15:40:00' },
      { label: '16:00', value: '16:00:00' },
      { label: '16:20', value: '16:20:00' },
      { label: '16:40', value: '16:40:00' },
      { label: '17:00', value: '17:00:00' },
      { label: '17:20', value: '17:20:00' },
      { label: '17:40', value: '17:40:00' },
      { label: '18:00', value: '18:00:00' },
      { label: '18:20', value: '18:20:00' },
      { label: '18:40', value: '18:40:00' },
      { label: '19:00', value: '19:00:00' },
      { label: '19:20', value: '19:20:00' },
      { label: '19:40', value: '19:40:00' },
      { label: '20:00', value: '20:00:00' },
      { label: '20:20', value: '20:20:00' },
      { label: '20:40', value: '20:40:00' },
      { label: '21:00', value: '21:00:00' },
      { label: '21:20', value: '21:20:00' },
      { label: '21:40', value: '21:40:00' },
      { label: '22:00', value: '22:00:00' },
      { label: '22:20', value: '22:20:00' },
      { label: '22:40', value: '22:40:00' },
      { label: '23:00', value: '23:00:00' },
      { label: '23:20', value: '23:20:00' },
      { label: '23:40', value: '23:40:00' },
      { label: '24:00', value: '24:00:00' },
    ]
  },

  getFifteenMinuteSlots: function () {
    return [
      { label: '00:00', value: '00:00:00' },
      { label: '00:15', value: '00:15:00' },
      { label: '00:30', value: '00:30:00' },
      { label: '00:45', value: '00:45:00' },
      { label: '01:00', value: '01:00:00' },
      { label: '01:15', value: '01:15:00' },
      { label: '01:30', value: '01:30:00' },
      { label: '01:45', value: '01:45:00' },
      { label: '02:00', value: '02:00:00' },
      { label: '02:15', value: '02:15:00' },
      { label: '02:30', value: '02:30:00' },
      { label: '02:45', value: '02:45:00' },
      { label: '03:00', value: '03:00:00' },
      { label: '03:15', value: '03:15:00' },
      { label: '03:30', value: '03:30:00' },
      { label: '03:45', value: '03:45:00' },
      { label: '04:00', value: '04:00:00' },
      { label: '04:15', value: '04:15:00' },
      { label: '04:30', value: '04:30:00' },
      { label: '04:45', value: '04:45:00' },
      { label: '05:00', value: '05:00:00' },
      { label: '05:15', value: '05:15:00' },
      { label: '05:30', value: '05:30:00' },
      { label: '05:45', value: '05:45:00' },
      { label: '06:00', value: '06:00:00' },
      { label: '06:15', value: '06:15:00' },
      { label: '06:30', value: '06:30:00' },
      { label: '06:45', value: '06:45:00' },
      { label: '07:00', value: '07:00:00' },
      { label: '07:15', value: '07:15:00' },
      { label: '07:30', value: '07:30:00' },
      { label: '07:45', value: '07:45:00' },
      { label: '08:00', value: '08:00:00' },
      { label: '08:15', value: '08:15:00' },
      { label: '08:30', value: '08:30:00' },
      { label: '08:45', value: '08:45:00' },
      { label: '09:00', value: '09:00:00' },
      { label: '09:15', value: '09:15:00' },
      { label: '09:30', value: '09:30:00' },
      { label: '09:45', value: '09:45:00' },
      { label: '10:00', value: '10:00:00' },
      { label: '10:15', value: '10:15:00' },
      { label: '10:30', value: '10:30:00' },
      { label: '10:45', value: '10:45:00' },
      { label: '11:00', value: '11:00:00' },
      { label: '11:15', value: '11:15:00' },
      { label: '11:30', value: '11:30:00' },
      { label: '11:45', value: '11:45:00' },
      { label: '12:00', value: '12:00:00' },
      { label: '12:15', value: '12:15:00' },
      { label: '12:30', value: '12:30:00' },
      { label: '12:45', value: '12:45:00' },
      { label: '13:00', value: '13:00:00' },
      { label: '13:15', value: '13:15:00' },
      { label: '13:30', value: '13:30:00' },
      { label: '13:45', value: '13:45:00' },
      { label: '14:00', value: '14:00:00' },
      { label: '14:15', value: '14:15:00' },
      { label: '14:30', value: '14:30:00' },
      { label: '14:45', value: '14:45:00' },
      { label: '15:00', value: '15:00:00' },
      { label: '15:15', value: '15:15:00' },
      { label: '15:30', value: '15:30:00' },
      { label: '15:45', value: '15:45:00' },
      { label: '16:00', value: '16:00:00' },
      { label: '16:15', value: '16:15:00' },
      { label: '16:30', value: '16:30:00' },
      { label: '16:45', value: '16:45:00' },
      { label: '17:00', value: '17:00:00' },
      { label: '17:15', value: '17:15:00' },
      { label: '17:30', value: '17:30:00' },
      { label: '17:45', value: '17:45:00' },
      { label: '18:00', value: '18:00:00' },
      { label: '18:15', value: '18:15:00' },
      { label: '18:30', value: '18:30:00' },
      { label: '18:45', value: '18:45:00' },
      { label: '19:00', value: '19:00:00' },
      { label: '19:15', value: '19:15:00' },
      { label: '19:30', value: '19:30:00' },
      { label: '19:45', value: '19:45:00' },
      { label: '20:00', value: '20:00:00' },
      { label: '20:15', value: '20:15:00' },
      { label: '20:30', value: '20:30:00' },
      { label: '20:45', value: '20:45:00' },
      { label: '21:00', value: '21:00:00' },
      { label: '21:15', value: '21:15:00' },
      { label: '21:30', value: '21:30:00' },
      { label: '21:45', value: '21:45:00' },
      { label: '22:00', value: '22:00:00' },
      { label: '22:15', value: '22:15:00' },
      { label: '22:30', value: '22:30:00' },
      { label: '22:45', value: '22:45:00' },
      { label: '23:00', value: '23:00:00' },
      { label: '23:15', value: '23:15:00' },
      { label: '23:30', value: '23:30:00' },
      { label: '23:45', value: '23:45:00' },
      { label: '24:00', value: '24:00:00' },
    ]
  },

  getTenMinuteSlots: function () {
    return [
      { label: '00:00', value: '00:00:00' },
      { label: '00:10', value: '00:10:00' },
      { label: '00:20', value: '00:20:00' },
      { label: '00:30', value: '00:30:00' },
      { label: '00:40', value: '00:40:00' },
      { label: '00:50', value: '00:50:00' },
      { label: '01:00', value: '01:00:00' },
      { label: '01:10', value: '01:10:00' },
      { label: '01:20', value: '01:20:00' },
      { label: '01:30', value: '01:30:00' },
      { label: '01:40', value: '01:40:00' },
      { label: '01:50', value: '01:50:00' },
      { label: '02:00', value: '02:00:00' },
      { label: '02:10', value: '02:10:00' },
      { label: '02:20', value: '02:20:00' },
      { label: '02:30', value: '02:30:00' },
      { label: '02:40', value: '02:40:00' },
      { label: '02:50', value: '02:50:00' },
      { label: '03:00', value: '03:00:00' },
      { label: '03:10', value: '03:10:00' },
      { label: '03:20', value: '03:20:00' },
      { label: '03:30', value: '03:30:00' },
      { label: '03:40', value: '03:40:00' },
      { label: '03:50', value: '03:50:00' },
      { label: '04:00', value: '04:00:00' },
      { label: '04:10', value: '04:10:00' },
      { label: '04:20', value: '04:20:00' },
      { label: '04:30', value: '04:30:00' },
      { label: '04:40', value: '04:40:00' },
      { label: '04:50', value: '04:50:00' },
      { label: '05:00', value: '05:00:00' },
      { label: '05:10', value: '05:10:00' },
      { label: '05:20', value: '05:20:00' },
      { label: '05:30', value: '05:30:00' },
      { label: '05:40', value: '05:40:00' },
      { label: '05:50', value: '05:50:00' },
      { label: '06:00', value: '06:00:00' },
      { label: '06:10', value: '06:10:00' },
      { label: '06:20', value: '06:20:00' },
      { label: '06:30', value: '06:30:00' },
      { label: '06:40', value: '06:40:00' },
      { label: '06:50', value: '06:50:00' },
      { label: '07:00', value: '07:00:00' },
      { label: '07:10', value: '07:10:00' },
      { label: '07:20', value: '07:20:00' },
      { label: '07:30', value: '07:30:00' },
      { label: '07:40', value: '07:40:00' },
      { label: '07:50', value: '07:50:00' },
      { label: '08:00', value: '08:00:00' },
      { label: '08:10', value: '08:10:00' },
      { label: '08:20', value: '08:20:00' },
      { label: '08:30', value: '08:30:00' },
      { label: '08:40', value: '08:40:00' },
      { label: '08:50', value: '08:50:00' },
      { label: '09:00', value: '09:00:00' },
      { label: '09:10', value: '09:10:00' },
      { label: '09:20', value: '09:20:00' },
      { label: '09:30', value: '09:30:00' },
      { label: '09:40', value: '09:40:00' },
      { label: '09:50', value: '09:50:00' },
      { label: '10:00', value: '10:00:00' },
      { label: '10:10', value: '10:10:00' },
      { label: '10:20', value: '10:20:00' },
      { label: '10:30', value: '10:30:00' },
      { label: '10:40', value: '10:40:00' },
      { label: '10:50', value: '10:50:00' },
      { label: '11:00', value: '11:00:00' },
      { label: '11:10', value: '11:10:00' },
      { label: '11:20', value: '11:20:00' },
      { label: '11:30', value: '11:30:00' },
      { label: '11:40', value: '11:40:00' },
      { label: '11:50', value: '11:50:00' },
      { label: '12:00', value: '12:00:00' },
      { label: '12:10', value: '12:10:00' },
      { label: '12:20', value: '12:20:00' },
      { label: '12:30', value: '12:30:00' },
      { label: '12:40', value: '12:40:00' },
      { label: '12:50', value: '12:50:00' },
      { label: '13:00', value: '13:00:00' },
      { label: '13:10', value: '13:10:00' },
      { label: '13:20', value: '13:20:00' },
      { label: '13:30', value: '13:30:00' },
      { label: '13:40', value: '13:40:00' },
      { label: '13:50', value: '13:50:00' },
      { label: '14:00', value: '14:00:00' },
      { label: '14:10', value: '14:10:00' },
      { label: '14:20', value: '14:20:00' },
      { label: '14:30', value: '14:30:00' },
      { label: '14:40', value: '14:40:00' },
      { label: '14:50', value: '14:50:00' },
      { label: '15:00', value: '15:00:00' },
      { label: '15:10', value: '15:10:00' },
      { label: '15:20', value: '15:20:00' },
      { label: '15:30', value: '15:30:00' },
      { label: '15:40', value: '15:40:00' },
      { label: '15:50', value: '15:50:00' },
      { label: '16:00', value: '16:00:00' },
      { label: '16:10', value: '16:10:00' },
      { label: '16:20', value: '16:20:00' },
      { label: '16:30', value: '16:30:00' },
      { label: '16:40', value: '16:40:00' },
      { label: '16:50', value: '16:50:00' },
      { label: '17:00', value: '17:00:00' },
      { label: '17:10', value: '17:10:00' },
      { label: '17:20', value: '17:20:00' },
      { label: '17:30', value: '17:30:00' },
      { label: '17:40', value: '17:40:00' },
      { label: '17:50', value: '17:50:00' },
      { label: '18:00', value: '18:00:00' },
      { label: '18:10', value: '18:10:00' },
      { label: '18:20', value: '18:20:00' },
      { label: '18:30', value: '18:30:00' },
      { label: '18:40', value: '18:40:00' },
      { label: '18:50', value: '18:50:00' },
      { label: '19:00', value: '19:00:00' },
      { label: '19:10', value: '19:10:00' },
      { label: '19:20', value: '19:20:00' },
      { label: '19:30', value: '19:30:00' },
      { label: '19:40', value: '19:40:00' },
      { label: '19:50', value: '19:50:00' },
      { label: '20:00', value: '20:00:00' },
      { label: '20:10', value: '20:10:00' },
      { label: '20:20', value: '20:20:00' },
      { label: '20:30', value: '20:30:00' },
      { label: '20:40', value: '20:40:00' },
      { label: '20:50', value: '20:50:00' },
      { label: '21:00', value: '21:00:00' },
      { label: '21:10', value: '21:10:00' },
      { label: '21:20', value: '21:20:00' },
      { label: '21:30', value: '21:30:00' },
      { label: '21:40', value: '21:40:00' },
      { label: '21:50', value: '21:50:00' },
      { label: '22:00', value: '22:00:00' },
      { label: '22:10', value: '22:10:00' },
      { label: '22:20', value: '22:20:00' },
      { label: '22:30', value: '22:30:00' },
      { label: '22:40', value: '22:40:00' },
      { label: '22:50', value: '22:50:00' },
      { label: '23:00', value: '23:00:00' },
      { label: '23:10', value: '23:10:00' },
      { label: '23:20', value: '23:20:00' },
      { label: '23:30', value: '23:30:00' },
      { label: '23:40', value: '23:40:00' },
      { label: '23:50', value: '23:50:00' },
      { label: '24:00', value: '24:00:00' },
    ]
  },

  getPhoneCode: function (country) {
    switch (country) {
      case 'KSA':
        return '966'
      case 'UAE':
        return '971'
      case 'KWT':
        return '965'
      case 'QAT':
        return '974'
      case 'THA':
        return '66'
      case 'TUR':
        return '90'
      default:
        return ''
    }
  },

  getComplaintTitles: function (type) {
    switch (type) {
      case 'C':
        return [
          'Yatch late',
          'Yacht not available',
          'Yacht maintenance',
          'Customer refused Reschedule the trip',
          `Customer didn't get full time for the trip`,
          'Late refund',
          'Others',
        ]
      case 'CH':
        return ['Not available Date', 'Chalet not clean', 'Late refund', 'Others']
      case 'E':
        return [
          'Late booking time',
          'Not available',
          'Maintenance',
          'Captain Attitude',
          'Customer refuse Reschedule the booking',
          `Customer didn't get Full time for the booking`,
          'Late refund',
          'Others',
        ]
      case 'S':
        return ['Late Delivery', 'Sold out', 'Damage item', 'Wrong item', 'Late refund', 'Others']
      case 'CT':
        return [
          'Cruise Late',
          'Cruise not available',
          'Cruise maintenance',
          'Customer refused Reschedule the trip',
          `Customer didn't get full time for the trip`,
          'Late refund',
          'Others',
        ]
      default:
        return []
    }
  },

  getComplaintActions: function (type) {
    switch (type) {
      case 'C':
        return ['Apology', 'Free Hours', 'Refund', 'Money compensation', 'Satisfied', 'Other']
      case 'CH':
        return ['Apology', 'Free Hours', 'Refund', 'Satisfied', 'Others']
      case 'E':
        return ['Apology', 'Free Hours', 'Refund', 'Satisfied', 'Others']
      case 'S':
        return ['Apology', 'Refund', 'Satisfied', 'Others']
      case 'CT':
        return ['Apology', 'Refund', 'Satisfied', 'Others']
      default:
        return []
    }
  },

  getBreakDurationOptions: function () {
    return [
      { label: '10 Minutes', value: 10 },
      { label: '20 Minutes', value: 20 },
      { label: '30 Minutes', value: 30 },
      { label: '1 Hour', value: 60 },
    ]
  },
}
